/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.Twitter = class Twitter {
  constructor(el) {
    this.el = el;
    this.view = new Buyapowa.Views.Twitter(this.el, this);
  }

  shareMessageChanged(message) {
    const fullMessage = `${message} ${this.view.getShareUrl()}`;
    const shareLink = `${this.view.getSharePath()}${encodeURIComponent(fullMessage)}`;

    return this.view.updateShareLink(shareLink);
  }
};